// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pledge-selector > header .btn[data-v-c8491a8a] {\n  margin-left: auto;\n}\n.error-label[data-v-c8491a8a] {\n  font-size: 10px;\n  color: red;\n  width: 100%;\n  display: block;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
